/**
 * More granular access rights to specific things in the system
 */
export var PermissionsResourceType;
(function (PermissionsResourceType) {
    PermissionsResourceType["Webshops"] = "Webshops";
    PermissionsResourceType["Groups"] = "Groups";
    PermissionsResourceType["GroupCategories"] = "GroupCategories";
    PermissionsResourceType["OrganizationTags"] = "OrganizationTags";
    PermissionsResourceType["RecordCategories"] = "RecordCategory";
    PermissionsResourceType["Events"] = "Events";
    /**
     * Sending emails and other communication via a sender and viewing the history of sent messages
     */
    PermissionsResourceType["Senders"] = "Senders";
})(PermissionsResourceType || (PermissionsResourceType = {}));
//# sourceMappingURL=PermissionsResourceType.js.map